<sick-base-app
  appName="{{ 'APP.TITLE' | translate }}"
  [customFunctions]="customFunctions"
  (buttonClicked)="onButtonClicked($event)"
></sick-base-app>
